<template>
  <div>
    <barcode-reader v-show="showBarcodeReader"
                    :start-scan.sync="startScan"
                    :settings="settings.barcodeReaderSettings"
                    @barcode-detected="getProductByBarcode($event)"></barcode-reader>

    <div class="panel" v-show="showQuickOrder">
      <div class="panel-body">
        <quick-order
                     :show-quick-order="showQuickOrder"
                     :barcode="barcode"
                     :template-id="quickOrderTemplate"></quick-order>
        <div class="row">
          <div class="text-center text-sm-right col-xs-12 col-md-6 col-md-push-6">
            <button class="btn c1-bg btn-scan-barcode" @click="scanBarcode">Scan For Other Product</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import QuickOrder from './QuickOrder';
  import BarcodeReader from '../InputDevices/BarcodeReader';

  export default {
    name: 'QuickOrderByBarcode',
    components: {
      QuickOrder, BarcodeReader
    },
    props: {
      showWebcamFeatures: Boolean,
      quickOrderTemplate: Number,
      settings: {
        type: Object,
        default: () => ({
          barcodeReaderSettings: {},
        }),
        required: false
      },
    },
    data() {
      return {
        barcode: '',  //4684
        //templateId: '3438', //3438
        startScan: false,
        showBarcodeReader: true,
        showQuickOrder: false,
      };
    },
    watch: {
      showWebcamFeatures: function (n, o) {
        if (!n) {
          this.startScan = false;
        }
      },
      //startScan: function (n, o) {
      //  console.log("QuickOrderByBarcode - startScan: " + n);
      //},
    },
    methods: {
      scanBarcode: function () {
        this.showQuickOrder = false;
        this.showBarcodeReader = true;
        this.startScan = true;
      },
      getProductByBarcode(detectedCode) {
        //console.log(detectedCode);
        if (!detectedCode || detectedCode === '') return;

        this.showQuickOrder = true;
        this.showBarcodeReader = false;
        this.startScan = false;

        //search product by barcode
        this.barcode = detectedCode;
      }
    }
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// EcomCore/Components/Products/QuickOrderByBarcode.vue